import { Component, OnDestroy, OnInit } from '@angular/core';
import { ConfigService } from '@app/@core/config/config.service';
import { ProductTypeEnum } from '@app/@core/enums/product-type.enum';
import { CommonHelper } from '@app/@core/helpers';
import { UserPrefrencesModel } from '@app/@shared/models/users.model';
import { UsersService } from '@services/users.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-main-header',
  templateUrl: './main-header.component.html',
  styleUrls: ['./main-header.component.scss']
})
export class MainHeaderComponent implements OnInit, OnDestroy {
  hidePopup = true;
  unSubscribe$: Subject<any> = new Subject();
  userPreferences: UserPrefrencesModel;
  productType = ProductTypeEnum;
  constructor(
    public usersService: UsersService,
    private readonly commonHelper: CommonHelper,
    public readonly configService: ConfigService
  ) { }

  ngOnInit(): void {

    // kullanıcı avatarını çekiyoruz.
    this.usersService.userAvatar
      .pipe(takeUntil(this.unSubscribe$))
      .subscribe((avatar: string) => {
        this.usersService.userValue.UserAvatar = avatar;
      });
  }

  /**
   * Logo eventinda kullanıcı tercihlerinde seçili ana sayfa hangisi ise o sayfaya yönlendirme işlemi yapıyoruz.
   */
  onEvent(): void {
    this.userPreferences = {
      pageID: 0,
      facilityID: '-'
    };

    this.usersService.getUserPreferences(this.userPreferences).pipe(takeUntil(this.unSubscribe$)).subscribe((res: any) => {
      // seçili ana sayfaya yönlendirme yapıyoruz.
      this.commonHelper.homePageRedirect(res.HomepageSelection);
    });
  }

  /**
   * aboneliklerden çık
   */
  ngOnDestroy(): void {
    this.unSubscribe$.next();
    this.unSubscribe$.complete();
  }
}
